module.exports = {"id":"222429","name":"Andrés Cubas","rating":"74","photo":"./data/images/photos/3/222429.png","club":{"name":"Fl. Varela","logo":"./data/images/clubs/Fl.Varela.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresCubas0.json
// module id = 388
// module chunks = 0